import { useRoundInvitations } from "@/hooks/useRoundInvitations";

/**
 * Component that listens for round invitations and auto-redirects the user.
 * Should be placed at the app root level.
 */
export const RoundInvitationListener = () => {
  useRoundInvitations();
  return null;
};
